export default __webpack_public_path__ + "img/visa.16e4e27d.svg";